module.exports = __webpack_public_path__ + "img/procedure.923e8489.png";